import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'module-tsl-ui-modal';
import Wizard from './components/Wizard';
import Agreement from './components/Agreement';
import SellerData from './components/SellerData';

var validateAgrement = function validateAgrement(values) {
  return values.agreements ? {} : {
    agreements: 'You have to accept the agreements'
  };
};

var SellerRegistrationModal = function SellerRegistrationModal(_ref) {
  var showModal = _ref.showModal,
      onHideModal = _ref.onHideModal,
      onSubmitForm = _ref.onSubmitForm,
      onNext = _ref.onNext,
      countries = _ref.countries,
      titles = _ref.titles,
      generalTerms = _ref.generalTerms,
      additionalTerms = _ref.additionalTerms,
      withDebug = _ref.withDebug;
  return /*#__PURE__*/React.createElement("div", {
    className: "seller-registration-modal"
  }, /*#__PURE__*/React.createElement(Modal, {
    title: "Update your personal contact information",
    showModal: showModal,
    onHideModal: onHideModal,
    size: "lg"
  }, /*#__PURE__*/React.createElement(Wizard, {
    withDebug: withDebug,
    initialValues: {
      title: '',
      firstname: '',
      lastname: '',
      country: '',
      address_line1: '',
      address_line2: '',
      address_line3: '',
      city: '',
      postalcode: '',
      state: '',
      agreements: false
    },
    onNext: onNext,
    onSubmit: function onSubmit(values, actions) {
      onSubmitForm(values);
      actions.setSubmitting(false);
    }
  }, /*#__PURE__*/React.createElement(SellerData, {
    onHideModal: onHideModal,
    countries: countries,
    titles: titles
  }), /*#__PURE__*/React.createElement(Agreement, {
    validate: validateAgrement,
    generalTerms: generalTerms,
    additionalTerms: additionalTerms
  }))));
};

SellerRegistrationModal.displayName = "SellerRegistrationModal";
SellerRegistrationModal.propTypes = {
  generalTerms: PropTypes.string,
  additionalTerms: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  titles: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  showModal: PropTypes.bool,
  onHideModal: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  onNext: PropTypes.func,
  withDebug: PropTypes.bool
};
SellerRegistrationModal.defaultProps = {
  generalTerms: '123 general terms',
  additionalTerms: '123 additional terms',
  countries: [{
    name: 'UK',
    label: 'United Kingdom'
  }, {
    name: 'IT',
    label: 'Italy'
  }],
  titles: [{
    name: 'Mr.',
    label: 'Mr.'
  }, {
    name: 'Ms.',
    label: 'Ms.'
  }],
  showModal: true,
  withDebug: false
};
export default SellerRegistrationModal;